import { render, staticRenderFns } from "./ProductSaisie.vue?vue&type=template&id=0187f3a2&scoped=true&"
import script from "./ProductSaisie.vue?vue&type=script&lang=js&"
export * from "./ProductSaisie.vue?vue&type=script&lang=js&"
import style0 from "./ProductSaisie.vue?vue&type=style&index=0&id=0187f3a2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0187f3a2",
  null
  
)

export default component.exports